export const getArtisticHandle = () => {
  const url = new URL(window.location.href);
  const artisticHandle = url.searchParams.get('art');
  return artisticHandle;
};
